import { Link } from '@tanstack/react-router';

/**
 * Link to a category listing.
 *
 * Every card used to emit a raw `<a href={`/category/${slug}`}>`. Two problems
 * with that: the Arabic slug went out unencoded, so the href never matched the
 * percent-encoded form used by the canonical tag and the sitemap, and the plain
 * anchor bypassed the router — each in-site category click cost a full document
 * request instead of a client-side navigation.
 *
 * `search={{ page: undefined }}` keeps the URL at the bare category path;
 * `?page=1` is a duplicate of it.
 */
export function CategoryLink({
  slug,
  name,
  className,
}: {
  slug: string;
  name: string;
  className?: string;
}) {
  return (
    <Link
      to="/category/$"
      params={{ _splat: slug }}
      search={{ page: undefined }}
      className={className}
    >
      {name}
    </Link>
  );
}
